import React, { useEffect, useState } from "react";
import { Editor } from "@tinymce/tinymce-react";
import { createNewsletter } from "../../../project/services/NewsletterService";
import Header from '../inc/Header';
import Navigation from '../inc/Navigation';
import { ToastContainer } from 'react-toastify';
import { Link, useNavigate } from 'react-router-dom';
import { listLanguage } from "../../request/Request";
import useAlerteSortie, { confirmerSortie } from "../../hooks/useAlerteSortie";
import { BoutonEnregistrer } from "../inc/Loading";
import Failed, { Warning } from "../inc/Failed";

export default function NouveauNewsletter() {

    const [date, setDate] = useState("");
    const [titre, setTitre] = useState("");
    const [numero, setNumero] = useState("");
    const [cover, setCover] = useState(null);
    const [content, setContent] = useState("");
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [hasModifications, setHasModifications] = useState(false);
    useAlerteSortie(hasModifications && !loading);
    const [languages, setLanguages] = useState([]);
    const [selectedLanguage, setSelectedLanguage] = useState("");
    const navigate = useNavigate();
    const lesLangues = async () => {
        const reponse = await listLanguage();
        if (reponse.status === 200) {
            setLanguages(reponse.data);
            if (reponse.data.length > 0) {
                setSelectedLanguage(reponse.data[0].idlanguage); 
            }
        }
    };

    let langageList = [];
    for (let i = 0; i < languages.length; i++) {
        langageList.push(
            <div className="form-check form-check-inline" key={languages[i].idlanguage}>
                <input
                    className="form-check-input"
                    type="radio"
                    name="language"
                    id={`lang-${languages[i].idlanguage}`}
                    value={languages[i].idlanguage}
                    checked={selectedLanguage === languages[i].idlanguage}
                    onChange={() => setSelectedLanguage(languages[i].idlanguage)}
                />
                <label className="form-check-label" htmlFor={`lang-${languages[i].idlanguage}`}>
                    {languages[i].code}
                </label>
            </div>
        );
    }
    useEffect(() => {
        lesLangues();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage("");

        try {
            // Prépare l'objet newsletter
            const newsletter = {
                titre,
                numero: parseInt(numero, 10),
                date_sortie: date,
                content,
                cover: "",
                isDeleted: 0,
                language: { idlanguage: selectedLanguage } // <-- objet au lieu du simple id
            };


            // Appel API et récupération de la réponse
            const response = await createNewsletter(newsletter, cover);

            // Vérifie si l'insertion est réussie
            if (response && response.id_newsletter) {
                // Réinitialise le formulaire
                setDate("");
                setTitre("");
                setNumero("");
                setCover(null);
                setContent("");
                setHasModifications(false);

                // Redirection avec state success
                navigate(process.env.REACT_APP_ADMIN_URL + '/list-Newsletter', { state: { success: true } });
            } else {
                setMessage("Erreur lors de l'enregistrement.");
            }
        } catch (err) {
            setMessage("Erreur lors de l'enregistrement.");
        } finally {
            setLoading(false);
        }
    };


    return (
        <><Header /><Navigation /><ToastContainer />
            <main id="main" className="main">
<div className="pagetitle">
                    <h1>Newsletter</h1>
                    <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to={process.env.REACT_APP_ADMIN_URL + "/dashboard"}>Accueil</Link></li>
                            <li className="breadcrumb-item"><Link to={process.env.REACT_APP_ADMIN_URL + "/list-Newsletter"}>Newsletters</Link></li>
                            <li className="breadcrumb-item active">Nouveau</li>
                        </ol>
                    </nav>
                </div>
                <section className="section">
                    <div className="row">
                        <div className="card">
                            <div className="card-body">
                                <h2 className="card-title">Nouvelle newsletter</h2>
                                <form className="formulaire form-actualite" onSubmit={handleSubmit} onChange={() => setHasModifications(true)}>
                                    {/* Numéro */}
                                    <div className="row mb-3">
                                        <label htmlFor="inputNumero" className="col-sm-2 col-form-label">
                                            Numéro
                                        </label>
                                        <div className="col-sm-10">
                                            <input
                                                type="number"
                                                className="form-control"
                                                id="numero"
                                                value={numero}
                                                onChange={e => setNumero(e.target.value)}
                                                required
                                                min={1}
                                            />
                                        </div>
                                    </div>

                                    {/*langues*/}

                                    <div className="row mb-3">
                                        <label className="col-sm-2 col-form-label">Langue</label>
                                        <div className="col-sm-10">{langageList}</div>
                                    </div>
                                    {/* Date */}
                                    <div className="row mb-3">
                                        <label htmlFor="inputDate" className="col-sm-2 col-form-label">
                                            Date
                                        </label>
                                        <div className="col-sm-10">
                                            <input
                                                type="date"
                                                className="form-control"
                                                id="date"
                                                value={date}
                                                onChange={e => setDate(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>
                                    {/* Titre */}
                                    <div className="row mb-3">
                                        <label htmlFor="inputText" className="col-sm-2 col-form-label">
                                            Titre
                                        </label>
                                        <div className="col-sm-10">
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="titre"
                                                value={titre}
                                                onChange={e => setTitre(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>
                                    {/* Cover */}
                                    <div className="row mb-3">
                                        <label htmlFor="inputFile" className="col-sm-2 col-form-label">
                                            Image de couverture{" "}
                                            <span className="max-size-indication">
                                                ( &le; {process.env.REACT_APP_MAX_IMAGE_SIZE} Mo)
                                            </span>
                                        </label>
                                        <div className="col-sm-10">
                                            <input
                                                type="file"
                                                className="form-control"
                                                id="cover"
                                                name="cover"
                                                accept="image/*"
                                                onChange={e => setCover(e.target.files[0])}
                                                required
                                            />
                                            {cover && cover.size * 0.000001 > process.env.REACT_APP_MAX_IMAGE_SIZE && (
                                                <div className="mt-2"><Warning message="Taille de l'image de couverture trop grande" /></div>
                                            )}
                                        </div>
                                    </div>
                                    {/* Content */}
                                    <div className="row mb-3">
                                        <label htmlFor="content" className="col-sm-2 col-form-label">
                                            Texte
                                        </label>
                                        <div className="col-sm-10">
                                            <div id="ckeditor-wrapper">
                                                <Editor
                                                    apiKey={process.env.REACT_APP_API_KEY_TINY_MCE}
                                                    value={content}
                                                    onEditorChange={(newValue, editor) => {
                                                        setContent(newValue);
                                                        if (editor.isDirty()) setHasModifications(true);
                                                    }}
                                                    init={{
                                                        height: 500,
                                                        menubar: 'favs view file edit insert format tools table',
                                                        plugins: [
                                                            'fullscreen', 'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'print', 'preview', 'anchor',
                                                            'searchreplace', 'visualblocks', 'code', 'insertdatetime', 'media', 'table', 'paste', 'wordcount', 'template'
                                                        ],
                                                        style_formats: [
                                                            {
                                                                title: 'Ombre gris',
                                                                block: 'div',
                                                                classes: 'shadow-gray',
                                                                wrapper: true,
                                                            },
                                                            {
                                                                title: 'paragraph',
                                                                block: 'div',
                                                                classes: 'clear-paragraph',
                                                                wrapper: true,
                                                            },
                                                        ],
                                                        templates: [
                                                            {
                                                                title: 'Deux colonnes (flex)',
                                                                description: 'Insérer une structure à deux colonnes',
                                                                content:
                                                                    '<div className="two-columns"><div><p>Colonne 1...</p></div><div><p>Colonne 2...</p></div></div>'
                                                            },
                                                        ],
                                                        toolbar: 'template | fullscreen undo redo | formatselect | ' +
                                                            'bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat',
                                                        content_style: `
                                                                                                            body{font-family:AdriaGrotesk-Thin;}
                                                                                                            .two-columns{display:flex; gap:50px;}
                                                                                                            .two-columns > div{flex:1;}
                                                                                                            .shadow-gray{  background-color: #f7f7f7; 
                                                                                                                padding: 20px 30px;        
                                                                                                                border-radius: 34px;        
                                                                                                                box-shadow: 0 4px 10px rgba(0,0,0,0.1);
                                                                                                                max-width: 1240px;   }
                                                                                                            `,
                                                        font_family_formats: "Roboto Medium=Roboto-Medium;Roboto Light=Roboto-Light;Roboto Thin=Roboto-Thin;Roboto Black=Roboto-Black;Roboto Regular=Roboto-Regular;Roboto Bold=Roboto-Bold;",
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {message && (
                                        <div className="row mb-3">
                                            <label className="col-sm-2 col-form-label"></label>
                                            <div className="col-sm-10"><Failed message={message} /></div>
                                        </div>
                                    )}
                                    <div className="form-actions">
                                        <BoutonEnregistrer isSaving={loading} />
                                        <Link to={process.env.REACT_APP_ADMIN_URL + "/list-Newsletter"} className="btn btn-outline-secondary"
                                            onClick={(e) => { if (!confirmerSortie(hasModifications)) e.preventDefault(); }}>Annuler</Link>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
            </main></>
    );
}

